module.exports = __webpack_public_path__ + "static/img/kf_cloud_00003.fa866db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00003.jpg
// module id = 174
// module chunks = 1